/* Mother Odessa — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- MOBILE NAV ---- */
  const hamburger = document.querySelector('.mo-header__hamburger');
  const mobileNav = document.querySelector('.mo-mobile-nav');
  const mobileClose = document.querySelector('.mo-mobile-nav__close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('is-open'));
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('is-open'));
  }

  /* ---- CART COUNT ---- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.mo-header__cart-count');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  /* ---- ADD TO CART INTERCEPT ---- */
  document.querySelectorAll('.mo-product__atc').forEach(btn => {
    btn.dataset.added = 'false';

    btn.addEventListener('click', function (e) {
      const form = this.closest('form');
      if (!form) return;
      e.preventDefault();

      // Already added — clicking again goes to cart
      if (this.dataset.added === 'true') {
        window.location.href = '/cart';
        return;
      }

      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      // Collect ALL form fields including properties
      const formData = new FormData(form);

      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(() => {
        // Mark as added — keep button persistent
        this.dataset.added = 'true';
        this.disabled = false;
        this.textContent = 'Added — View Cart →';
        this.style.background = '#1a5c2e';
        updateCartCount();
      })
      .catch(() => {
        this.textContent = 'Begin This Working';
        this.disabled = false;
      });
    });
  });

  /* ---- FADE-IN ON SCROLL ---- */
  const observerOptions = {
    threshold: 0.12,
    rootMargin: '0px 0px -60px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.mo-step, .mo-testimonial, .mo-card, .mo-receive-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    observer.observe(el);
  });

});
